<template>
<div style="height:100%!important; background:url('/img/asw-bg.jpeg'); background-repeat: round">
  <router-view style="height: 100%!important; " />
</div>
</template>
<script lang="ts" src="./App.ts" />
